export default __webpack_public_path__ + "static/media/img-01.66b93fae.png";